webpackJsonp([1,17],{

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListSkus',
	  props: ['parent', 'parentId', 'filters'],
	  data: function data() {
	    return {
	      skus: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    user: function user(state) {
	      return state.user;
	    },
	    city: function city(state) {
	      return state.city;
	    }
	  })),
	  mounted: function mounted() {
	    this.load();
	  },
	
	  watch: {
	    filters: function filters(newFilters) {
	      this.filter = newFilters;
	      this.load();
	    }
	  },
	  methods: (0, _extends3.default)({
	    getRouteParams: function getRouteParams(sku) {
	      var routeData = {};
	      routeData = {
	        name: 'sku',
	        params: {
	          categorySlug: sku.product.subcategory.category.slug,
	          subcategorySlug: sku.product.subcategory.slug,
	          productSlug: sku.product.slug,
	          skuSlug: sku.slug,
	          skuId: sku.id
	        }
	      };
	      return routeData;
	    },
	    load: function load() {
	      var _this = this;
	
	      var city = this.city ? '&city_id=' + this.city.id : '';
	      var filters = this.filters ? '&filters=' + _lodash2.default.join(this.filters, '_') : '';
	      var uri = '?parent=' + this.parent + '&id=' + this.parentId + city + filters;
	      this.skus = false;
	      this.$http.get('skus' + uri).then(function (response) {
	        _this.skus = response.data.data;
	        _this.$emit('loaded', 'skus');
	      });
	    }
	  }, (0, _vuex.mapActions)([]))
	};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(26)
	
	/* template */
	var __vue_template__ = __webpack_require__(43)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-skus"
	  }, [(!_vm.skus) ? _c('loading') : _c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.skus), function(sku) {
	    return _c('div', {
	      staticClass: "col-sm-6 col-md-4",
	      class: {
	        'col-lg-3': _vm.parent == 'catalog'
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "to": _vm.getRouteParams(sku),
	        "id": 'sku-' + sku.id
	      }
	    }, [_c('div', {
	      staticClass: "product-catalog-item with-prices"
	    }, [_c('div', {
	      staticClass: "chevron visible-xs"
	    }, [_c('i', {
	      staticClass: "fa fa-angle-right fa-3x"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "img-container"
	    }, [_c('img', {
	      staticClass: "img-responsive-center",
	      attrs: {
	        "src": sku.image,
	        "alt": sku.title + ' - Loca.Shop'
	      }
	    })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(sku.title))]), _vm._v(" "), _c('p', [(parseInt(sku.quantity_companies) == 1) ? [_vm._v("Em "), _c('b', [_vm._v(_vm._s(sku.unique_company))]), _vm._v(" por:")] : [_vm._v("Em "), _c('b', [_vm._v(_vm._s(sku.quantity_companies) + " locadoras")]), _vm._v(" a partir de:")]], 2), _vm._v(" "), _c('p', {
	      staticClass: "prices"
	    }, [(sku.price_day > 0) ? [_c('strong', {
	      staticClass: "text-success"
	    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_day)))]), _vm._v(" "), _c('small', [_vm._v("por dia")]), _c('br')] : _vm._e(), _vm._v(" "), (sku.price_week > 0) ? [_c('strong', {
	      staticClass: "text-success"
	    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_week)))]), _vm._v(" "), _c('small', [_vm._v("por semana")]), _c('br')] : _vm._e(), _vm._v(" "), (sku.price_biweek > 0) ? [_c('strong', {
	      staticClass: "text-success"
	    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_biweek)))]), _vm._v(" "), _c('small', [_vm._v("por quinzena")]), _c('br')] : _vm._e(), _vm._v(" "), (sku.price_month > 0) ? [_c('strong', {
	      staticClass: "text-success"
	    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_month)))]), _vm._v(" "), _c('small', [_vm._v("por mês")])] : _vm._e()], 2)])])], 1)
	  }), 0)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListProductsMenu',
	  props: ['subcategoryId'],
	  data: function data() {
	    return {
	      products: false
	    };
	  },
	  mounted: function mounted() {
	    this.getProducts();
	  },
	
	  methods: (0, _extends3.default)({
	    getRouteParams: function getRouteParams(product) {
	      return {
	        name: 'product',
	        params: {
	          categorySlug: product.subcategory.category.slug,
	          subcategorySlug: product.subcategory.slug,
	          productSlug: product.slug,
	          productId: product.id
	        }
	      };
	    },
	    getProducts: function getProducts() {
	      var _this = this;
	
	      var subcategoryId = this.subcategoryId || 0;
	      this.$http.get('products?sort=name&with=counter&subcategory_id=' + subcategoryId).then(function (response) {
	        _this.products = response.data.data;
	        _this.$emit('loaded', 'products_menu');
	      }, function (response) {
	        console.log('error: Loading products resource from API');
	      });
	    }
	  }, (0, _vuex.mapActions)(['loadProducts']))
	};

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _ListProductsMenu = __webpack_require__(228);
	
	var _ListProductsMenu2 = _interopRequireDefault(_ListProductsMenu);
	
	var _ListSkus = __webpack_require__(41);
	
	var _ListSkus2 = _interopRequireDefault(_ListSkus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PageSubcategory',
	  components: {
	    ListProductsMenu: _ListProductsMenu2.default,
	    ListSkus: _ListSkus2.default
	  },
	  data: function data() {
	    return {
	      subcategoryId: this.$route.params.subcategoryId,
	      subcategory: false,
	      tagInterval: false,
	      loaded: {
	        skus: false,
	        productsMenu: false
	      }
	    };
	  },
	  mounted: function mounted() {
	    this.getSubcategory();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.tagInterval) {
	      clearInterval(this.tagInterval);
	    }
	  },
	
	  methods: (0, _extends3.default)({
	    loadedEvent: function loadedEvent(type) {
	      if (type === 'skus') this.loaded.skus = true;
	      if (type === 'products_menu') this.loaded.productsMenu = true;
	    },
	    getSubcategory: function getSubcategory() {
	      var _this = this;
	
	      this.loadSubcategory({ id: this.subcategoryId }).then(function (response) {
	        _this.subcategory = response.data;
	      }, function (response) {
	        console.log('error: Loading subcategory resource from API');
	      });
	    }
	  }, (0, _vuex.mapActions)(['loadSubcategory']))
	};

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(121)
	
	/* template */
	var __vue_template__ = __webpack_require__(304)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(163)
	
	/* template */
	var __vue_template__ = __webpack_require__(300)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-home"
	  }, [_c('div', {
	    staticClass: "space-20"
	  }), _vm._v(" "), _c('transition-group', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(!_vm.loaded.skus || !_vm.loaded.productsMenu) ? _c('loading', {
	    key: "loading"
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loaded.skus && _vm.loaded.productsMenu),
	      expression: "loaded.skus && loaded.productsMenu"
	    }],
	    key: "content",
	    staticClass: "container"
	  }, [_c('p', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_vm._v("Home")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-double-right"
	  }), _vm._v(" " + _vm._s(_vm.subcategory.name) + "\n      ")], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('list-products-menu', {
	    attrs: {
	      "subcategory-id": _vm.subcategoryId
	    },
	    on: {
	      "loaded": _vm.loadedEvent
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('list-skus', {
	    attrs: {
	      "parent": "subcategory",
	      "parent-id": _vm.subcategoryId
	    },
	    on: {
	      "loaded": _vm.loadedEvent
	    }
	  })], 1)])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-products"
	  }, [(_vm.products) ? _c('ul', {
	    staticClass: "list-group"
	  }, _vm._l((_vm.products), function(product) {
	    return _c('router-link', {
	      staticClass: "list-group-item",
	      attrs: {
	        "to": _vm.getRouteParams(product)
	      }
	    }, [_vm._v("\n      " + _vm._s(product.name) + " "), _c('span', {
	      staticClass: "badge"
	    }, [_vm._v(_vm._s(product.counter))])])
	  }), 1) : _vm._e()])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.e8f9599f405fbd1215fb.js